export default __webpack_public_path__ + "static/media/hola_2.a85776a2.png";